<app-modal
  #discardChangesModal
  [modalMessage]="app.text.app.discardChanges"
  [modalTitle]="app.text.warehouseGroup.modalTitle"
  (ok)="discardChanges()"
>
</app-modal>

<div class="row mt-2">
  <div class="col-md-12">
    <div>
      <app-paginator
        [length]="app.warehouseGroup.warehouseGroups.length"
        [index]="app.paginator.focus"
        (focus)="app.paginator.focus = $event"
      ></app-paginator>

      <div class="tableFixHead">
        <table class="table table-striped spacing-table">
          <thead>
            <tr>
              <th *ngFor="let column of getWarehouseGroupColumns()">
                <div *ngIf="column !== 'actions'" class="d-inline-flex">
                  <!-- Sorting and headers -->
                  <div
                    [ngClass]="{
                      'resize-table': app.table.canColumnBeResized(
                        'warehouseGroup.' + column
                      )
                    }"
                  >
                    <span
                      (click)="
                        app.table.toggleSortDirection(
                          'warehouseGroup.' + column
                        );
                        app.table.sort(app.warehouseGroup.warehouseGroups)
                      "
                    >
                      {{
                        app.field.handleSpecialLogicLabels(
                          "warehouseGroup." + column
                        )
                      }}
                    </span>
                  </div>
                  &nbsp;
                  <span
                    *ngIf="'warehouseGroup.' + column === app.table.sortField"
                  >
                    <i
                      *ngIf="app.table.sortDirection === 1"
                      class="fa fa-chevron-up"
                    ></i>
                    <i
                      *ngIf="app.table.sortDirection === -1"
                      class="fa fa-chevron-down"
                    ></i>
                  </span>
                </div>

                <span *ngIf="column === 'actions'" class="pointer">
                  {{ app.text.warehouseGroup.actions }}
                </span>

                <!-- Table filter -->
                <div *ngIf="app.filterTable.getFilterTableColumns(column)">
                  <app-filter-table
                    [column]="column"
                    [columns]="getWarehouseGroupColumns()"
                    [docType]="'warehouseGroup'"
                    [cleanDocs]="app.warehouseGroup.cleanWarehouseDocs"
                    [selectedFilters]="selectedFilters"
                    (resultedDocs)="
                      app.filterTable.getFilterResults($event, 'warehouseGroup')
                    "
                  >
                  </app-filter-table>
                </div>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr
              *ngFor="
                let item of app.paginator.getPage(
                  app.warehouseGroup.warehouseGroups
                )
              "
            >
              <td class="p-1" *ngFor="let column of getWarehouseGroupColumns()">
                <div [ngSwitch]="app.table.getColumnTypeDisplay(column)">
                  <div *ngSwitchCase="'actions'">
                    <!-- Actions -->
                    <span class="actions">
                      <button
                        *ngIf="app.unlockedId !== item['_id']"
                        class="btn btn-edit btn-sm"
                        [title]="app.text.app.edit"
                        (click)="app.warehouseGroup.edit(item)"
                      >
                        <i class="fa fa-edit">&nbsp;&nbsp;</i>
                        <span>{{ app.text.app.edit }}</span>
                      </button>

                      <div *ngIf="app.unlockedId === item['_id']">
                        <span
                          *ngIf="
                            app.warehouseGroup.modelHasChanges();
                            then thenBlock;
                            else elseBlock
                          "
                        >
                        </span>
                      </div>
                      <!-- then block - edit warehouse and there are changes  -->
                      <ng-template #thenBlock>
                        <button
                          *ngIf="app.warehouseGroup.modelHasChanges()"
                          class="btn btn-sm btn-save"
                          [title]="app.text.warehouseGroup.save"
                          (click)="
                            app.warehouseGroup.save(
                              app.warehouseGroup.selectedWarehouse
                            )
                          "
                        >
                          <i class="fa fa-check"></i> {{ app.text.app.save }}
                        </button>
                        <button
                          class="btn btn-sm btn-clean"
                          (click)="discardChangesModal.open()"
                          [title]="app.text.warehouseGroup.discard"
                        >
                          <i class="fas fa-times"></i>&nbsp;
                          {{ app.text.post.cancel }}
                        </button>
                      </ng-template>
                      <!-- #else block - edit warehouse and there are no changs  -->
                      <ng-template #elseBlock>
                        <button class="btn btn-sm btn-save btn-save-disabled">
                          <i class="fa fa-check"></i> {{ app.text.app.save }}
                        </button>
                        <button
                          class="btn btn-sm btn-clean"
                          (click)="
                            app.unlockedId = null;
                            app.field.inputSubject.next(true)
                          "
                          [title]="app.text.warehouseGroup.close"
                        >
                          <i class="fas fa-times"></i>&nbsp;
                          {{ app.text.post.cancel }}
                        </button>
                      </ng-template>
                    </span>
                  </div>
                  <div *ngSwitchCase="'radio'">
                    <!-- Proactive -->
                    <span>
                      <!-- Read mode -->
                      <span *ngIf="app.unlockedId !== item['_id']">
                        <i
                          class="far fa-dot-circle"
                          *ngIf="item[column] === 'true'"
                        ></i>
                        <i
                          class="fal fa-circle"
                          *ngIf="item[column] === 'false'"
                        ></i>
                      </span>

                      <!-- Edit mode -->
                      <div *ngIf="app.unlockedId === item['_id']">
                        <div
                          class="badge cursor-pointer font-style proactive-cell edit-mode-cell"
                        >
                          <div
                            [ngClass]="{
                              'selected-option':
                                app.warehouseGroup.selectedWarehouse[column] ===
                                'true'
                            }"
                            (click)="
                              app.warehouseGroup.selectedWarehouse[column] =
                                'true'
                            "
                          >
                            Yes
                          </div>
                          <div
                            [ngClass]="{
                              'selected-option':
                                app.warehouseGroup.selectedWarehouse[column] ===
                                'false'
                            }"
                            (click)="
                              app.warehouseGroup.selectedWarehouse[column] =
                                'false'
                            "
                          >
                            No
                          </div>
                        </div>
                      </div>
                    </span>
                  </div>
                  <div *ngSwitchCase="'badge'">
                    <!-- Warehouse Impact -->
                    <span>
                      <!-- Read mode -->
                      <span
                        *ngIf="app.unlockedId !== item['_id']"
                        class="badge text-center"
                        [ngStyle]="
                          app.field.getColor(
                            'warehouseGroup.' + column,
                            item[column]
                          )
                        "
                      >
                        {{
                          app.field.getOptionText(
                            "warehouseGroup." + column,
                            item[column]
                          )
                        }}
                      </span>

                      <!-- Edit mode -->
                      <div
                        *ngIf="app.unlockedId === item['_id']"
                        class="custom-select-wrapper"
                      >
                        <div
                          class="badge cursor-pointer"
                          [ngStyle]="
                            app.field.getColor(
                              'warehouseGroup.' + column,
                              app.warehouseGroup.selectedWarehouse[column]
                            )
                          "
                          (click)="dropdownStatusOpen = !dropdownStatusOpen"
                        >
                          {{
                            app.field.getOptionText(
                              "warehouseGroup." + column,
                              app.warehouseGroup.selectedWarehouse[column]
                            )
                          }}
                          <i class="fa-solid fa-caret-down arrow"></i>
                        </div>

                        <div *ngIf="dropdownStatusOpen" class="custom-dropdown">
                          <div
                            *ngFor="
                              let opt of app.field.getOptions(
                                'warehouseGroup.' + column
                              )
                            "
                            class="dropdown-option"
                            (click)="
                              app.warehouseGroup.selectedWarehouse[column] =
                                opt;
                              dropdownStatusOpen = false
                            "
                          >
                            {{
                              app.field.getOptionText(
                                "warehouseGroup." + column,
                                opt
                              )
                            }}
                          </div>
                        </div>
                      </div>
                    </span>
                  </div>
                  <div *ngSwitchCase="'time'">
                    <!-- Update time and create time -->
                    {{ item[column] | date : "yyyy-MM-dd HH:mm:ss" }}
                  </div>
                  <!-- Regular columns -->
                  <div *ngSwitchCase="'normal'">
                    {{ item[column] }}
                  </div>
                </div>
              </td>
            </tr>
            <tr *ngIf="app.warehouseGroup.warehouseGroups.length === 0">
              <td colspan="99" class="p-1 text-center">
                {{ app.text.core.noResults }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>
